import { render, staticRenderFns } from "./debugCard__content.vue?vue&type=template&id=71c42f12"
import script from "./debugCard__content.vue?vue&type=script&lang=ts"
export * from "./debugCard__content.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports